var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewHelixLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 32,
    viewBox: "0 0 93 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4669 31.0481H4.29758C2.81954 31.0481 1.82106 29.5394 2.39875 28.1789L7.44349 16.2984C7.56565 15.9546 7.5549 15.7581 7.5549 15.7581H10.3162C10.3128 15.9931 10.2728 16.1508 10.1689 16.3993L5.27497 27.9654C5.16534 28.2245 5.35552 28.5115 5.63684 28.5115H9.36159C10.1104 28.5115 10.7868 28.0639 11.0795 27.3747L18.4022 10.1343C19.5857 7.34788 23.5323 7.34044 24.7262 10.1223L25.2478 11.3376L23.8234 14.5302L22.82 12.1852C22.3432 11.071 20.7629 11.0734 20.2896 12.189L12.999 29.3719C12.5678 30.3881 11.5708 31.0481 10.4669 31.0481Z",
    fill: "url(#paint0_radial_34_813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4669 0.47849H4.29758C2.81954 0.47849 1.82106 1.98723 2.39875 3.3477L7.44349 15.2282C7.56565 15.572 7.5549 15.7685 7.5549 15.7685H10.3162C10.3128 15.5335 10.2728 15.3758 10.1689 15.1273L5.27497 3.56116C5.16534 3.30208 5.35552 3.01511 5.63684 3.01511H9.36159C10.1104 3.01511 10.7868 3.46266 11.0795 4.1519L15.4252 14.3833L16.812 11.1416L12.999 2.1547C12.5678 1.13848 11.5708 0.47849 10.4669 0.47849Z",
    fill: "url(#paint1_radial_34_813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1749 20.0757L19.3831 17.1923L20.3065 19.3437C20.7781 20.4439 22.34 20.4537 22.8312 19.3535L27.4482 8.88173C27.5464 8.66561 27.8313 8.64596 27.959 8.83261L29.2655 10.7875C29.3244 10.8661 29.3343 10.9741 29.295 11.0723L24.9137 21.1414C23.6858 23.9607 19.6582 23.8723 18.558 21.0038L18.1749 20.0757Z",
    fill: "#8952E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8302 17.3002L26.4353 20.542L27.6044 23.4596C27.7026 23.6953 28.0268 23.7052 28.1446 23.4694L29.3235 21.0332C29.3628 20.9546 29.3628 20.8662 29.3235 20.7876L27.8302 17.3002Z",
    fill: "#2DD1DA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9233 12.1844C59.9714 12.1844 60.8677 12.4122 61.612 12.868C62.3715 13.3237 62.9488 13.9693 63.3437 14.8048C63.7539 15.6251 63.9589 16.5897 63.9589 17.6986V18.9062H55.5965C55.6269 20.2886 55.9763 21.3443 56.6447 22.0735C57.3283 22.7874 58.2777 23.1444 59.4929 23.1444C60.2676 23.1444 60.9512 23.076 61.5436 22.9393C62.1513 22.7874 62.7741 22.5747 63.4121 22.3013V24.0558C62.7893 24.3293 62.174 24.5267 61.5664 24.6483C60.9588 24.785 60.2372 24.8533 59.4018 24.8533C58.2473 24.8533 57.2219 24.6179 56.3257 24.147C55.4446 23.6761 54.7534 22.9773 54.2522 22.0507C53.7661 21.1089 53.523 19.962 53.523 18.61C53.523 17.2732 53.7433 16.1263 54.1838 15.1693C54.6395 14.2123 55.2699 13.4756 56.075 12.9591C56.8953 12.4426 57.8447 12.1844 58.9233 12.1844ZM58.9005 13.825C57.9435 13.825 57.1839 14.1364 56.6219 14.7592C56.075 15.3668 55.7484 16.2175 55.6421 17.3112H61.8626C61.8626 16.6124 61.7563 16.0048 61.5436 15.4883C61.331 14.9719 61.0044 14.5693 60.5638 14.2807C60.1385 13.9769 59.5841 13.825 58.9005 13.825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1921 24.6255H68.187V7.30821H70.1921V24.6255Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1855 12.4122V24.6255H75.1803V12.4122H77.1855ZM76.2057 7.83229C76.5095 7.83229 76.7753 7.93862 77.0032 8.15129C77.2462 8.34877 77.3678 8.66777 77.3678 9.1083C77.3678 9.53363 77.2462 9.85263 77.0032 10.0653C76.7753 10.278 76.5095 10.3843 76.2057 10.3843C75.8715 10.3843 75.5905 10.278 75.3626 10.0653C75.1348 9.85263 75.0208 9.53363 75.0208 9.1083C75.0208 8.66777 75.1348 8.34877 75.3626 8.15129C75.5905 7.93862 75.8715 7.83229 76.2057 7.83229Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7058 24.6905H48.5176V16.6012H39.6191V24.6905H37.4309V7.34598H39.6191V14.6822H48.5176V7.34598H50.7058V24.6905Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.437 12.4441L84.6524 18.414L80.232 24.6573H82.4878L85.8601 19.7811L89.1868 24.6573H91.4654L87.0222 18.414L85.8601 16.7985L82.7156 12.4441H80.437Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1841 12.4441H88.8756L86.4197 15.8823L87.5494 17.454L91.1841 12.4441Z",
    fill: "#8952E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_34_813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.74446 15.7581) rotate(113.091) scale(13.7759 5.79359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7174DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#7170DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD1DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_34_813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.08828 15.3166) rotate(-27.8241) scale(3.99875 5.71876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7172DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#736FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8952E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5508,
    height: 30.5508,
    fill: "white",
    transform: "translate(0 0.478119)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHelixLogo);
export default __webpack_public_path__ + "static/media/new_helix_logo.90ad5c90feb6d2322c020ef75adc9db0.svg";
export { ForwardRef as ReactComponent };